import HalfStar from "@/assets/icons/half-star.svg";
import Star from "@/assets/icons/star.svg";
import { cn } from "@/lib/utils";

export const StarRating = ({
  rating,
  scale = 5,
  starClassName,
  containerClassName,
}: {
  rating: number;
  scale?: number;
  starClassName?: string;
  containerClassName?: string;
}) => {
  // Calculate the number of full stars
  const decimalPart = rating - Math.floor(rating);
  const fullStars = decimalPart > 0.5 ? Math.ceil(rating) : Math.floor(rating);
  // Calculate the number of half stars
  const halfStars = decimalPart > 0 && decimalPart <= 0.5 ? 1 : 0;
  // Calculate the number of empty stars
  const emptyStars = scale - fullStars - halfStars;

  return (
    <div className={cn("flex items-center gap-3", containerClassName)}>
      {Array.from({ length: fullStars }).map((_, index) => (
        <Star
          key={index}
          className={cn("[&>path]:fill-brand-yellow", starClassName)}
        />
      ))}
      {halfStars > 0 && <HalfStar className={starClassName} />}
      {emptyStars > 0 &&
        Array.from({ length: emptyStars }).map((_, index) => (
          <Star
            key={index}
            className={cn("[&>path]:fill-brand-grey2", starClassName)}
          />
        ))}
    </div>
  );
};
